<template>
  <div class="touristType">
    <h1 class="tourist-type-title">景点</h1>
    <div class="tourist-type">
      <div class="tourist-type-upper">
        <div
          v-for="(item, index) in _ticketWindow"
          :key="item.key"
          class="individual-guest"
          :class="{
            'currentType': touristtype === index,
            'width100' : item.parentProportion == 1,
            'width48' : item.parentProportion == 2,
            'width30' : item.parentProportion == 3,
            }"
          @click="changeTouristType(index)">
          <div>
            <div>{{ item.displayName }}</div>
            <div class="text-en">{{ item.displayEnglishName }}</div>
          </div>
          <div class="current-logo-box">
            <img src="~@/assets/image/common/common_select.png" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { getGroupCheckList } from '@/service/common';
import { loginHandle } from '@/utiles/common.js'

export default {
  name: "touristType",
  data(){
    return {
      touristtype: 0,
      _ticketWindow: [],
    }
  },
  created(){
    this.init();
    this.touristtype = Number(this.$route.params.touristtype);
    if(this.$route.params.touristtype == 4){
      this.changeTouristType(4);
    }
  },
  methods: {
    init(){
      const ticketWindow = this.$store.state.ticketWindow;
      const _ticketWindow = {
        zgticketlistWindowList: ticketWindow.zgticketlistWindowList,
      };
      this._ticketWindow = Object.entries(_ticketWindow).map((item) => {
        return {
          displayName: item[1][0].mapName,
          displayEnglishName: item[1][0].mapEnglishName,
          key: item[0],
          parentProportion: item[1][0].parentProportion,
        }
      });
    },
    async checkRedirect(userInfo){
      // 导游无必跳
      if(!userInfo.extField1){
        const voucher = JSON.parse(window.localStorage.getItem('userInfo'));
        const { data } = await getGroupCheckList.call(this, {
          userId: voucher.userId
        });
        if(data.groupCheckInfos.length){
          const { checkStatus, checkReason } = data.groupCheckInfos[0];
          // 审核中
          if(checkStatus === '0'){
            this.$router.push('/success');
            return false;
          }
          // 审核拒绝
          if(checkStatus === '2'){
            sessionStorage.setItem('checkReason', checkReason);
            this.$router.push('/fail');
            return false;
          }
        };
        this.$router.push('/register');
        return false;
      };
      return true;
    },
    async changeTouristType(index){
      const _ticketWindow = this._ticketWindow;
      if(_ticketWindow[index].key === 'groupTicketlistWindowList'){
         // 2023-08-30 鞠帅修改 begin
        // 原
        // const userInfo = await this.$getGroupUserInfo();
        // 新
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log('-----------')
      console.log(userInfo)
      console.log('-----------')
      if(!userInfo){
        const _route = {
          fullPath: '/groupticketlist',
          query: this.$route.query
        };
        return loginHandle.login(_route);
      };
       await this.$updateGroupStatus();
       const newUserInfo = JSON.parse(localStorage.getItem('userInfo'))
      // 2023-08-30 鞠帅修改 end
        const checkGroup = await this.checkRedirect(newUserInfo);
        if(!checkGroup)return;
      }
      const path = `/zg/${index}/0`;
      if(this.$route.path === path)return;
      this.$router.push(path);
      this.touristtype = index;
      this.currentTouristTypeIndex = 0;
    },
  },
  computed: {
    ...mapState(['ticketWindow'])
  },
};
</script>

<style scoped lang='less'>
.touristType {
  padding: .36rem .266667rem .453333rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  margin: 0 .266667rem;
  border-radius: .506667rem;
  & > h1{
    font-size: .4rem;
    font-weight: bold;
    color: #333333;
    line-height: .56rem;
  };
  .tourist-type{
    // line-height: 1.493333rem;
    text-align: center;
    font-size: .4rem;
    margin-top: .266667rem;
    color: #333333;
    .tourist-type-upper{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      &:first-child{
        margin-bottom: 0.266667rem;
      }
      .individual-guest{
        box-shadow: 0 .053333rem .106667rem .026667rem rgba(193, 60, 48, 0.04);
        border-radius: .213333rem;
        border: 1px solid #F5F5F5;
        border-radius: .213333rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.493333rem;
        margin-bottom: 0.266667rem;
        .individual-guest-special{
          // font-size: ;
          line-height: 1.2;
          .text-en{
            font-size: .24rem;
            margin-top: .2rem;
          }
        }
      }
    }
    .current-logo-box{
      display: none;
    }
    .currentType{
      background: #F1F5F8;
      border: 1px solid #3B6D9C !important;
      color: #3B6D9C !important;
      position: relative;
      .current-logo-box{
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: -0.026667rem;
        width: 0.346667rem;
        height: 0.346667rem;
        bottom: -0.026667rem;
        border: 1px solid #3B6D9C;
        border-radius: .066667rem .066667rem .16rem .066667rem;
        img{
          width: 0.346667rem;
          height: 0.346667rem;
        }
      }
    }
  }
}

.width100{
  width: 100%;
}

.width48{
  width: 48%;
}

.width30{
  width: 30%;
}
</style>
